import type { IconProps } from './base';
import { BaseIcon } from './base';

export function IconBoolean(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 5C8 3.89543 8.89543 3 10 3H19C20.1046 3 21 3.89543 21 5V14C21 15.1046 20.1046 16 19 16H16V19C16 20.1046 15.1046 21 14 21H5C3.89543 21 3 20.1046 3 19V10C3 8.89543 3.89543 8 5 8H8V5ZM8 10H5V19H14V16H10C8.89543 16 8 15.1046 8 14V10ZM14 14H10V10H14V14ZM16 14V10C16 8.89543 15.1046 8 14 8H10V5L19 5V14H16Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
